import styled, { css } from 'styled-components'
import { theme } from './../../../../common'

export const StyledCarouselWrapper = styled.div`
    position: relative;
    z-index: 20;
    &:after {
        content: '';
        position: absolute;
        left: 0px;
        top: 0px;
        bottom: 0px;
        right: 0px;
        width: 100%;
        height: 100%;
        transition: .3s;
        background-color: ${theme.primary};
        opacity: .9;
        @media screen and (max-width: 576px) {
            display: none;
        }
    }
    &:hover {
        &:after {
            opacity: 0;
        }
    }
`

export const StyledCarouselControl = styled.div`
    position: absolute;
    z-index: 10;
    top: 50%;
    transform: translateY(-50%);
    ${({side}) =>  side === 'left' ? css`left: -5%;` : css`right: -5%;`}

    img {
        cursor: pointer;
        ${({side}) =>  side === 'left' ? css`transform: rotate(180deg);` : css``};
    }

    @media screen and (max-width: 576px) {
        display: none;
    }

`